import React from 'react';
// APOLLO
import emailTemplatesQuery from 'ApolloClient/Queries/emailTemplates';
import { graphql } from 'react-apollo';
// ANTD
import Table from 'antd/lib/table';
import ActionMenu from './ActionMenu';

const columns = [
  {
    title: 'TITLE',
    dataIndex: 'title',
    key: 'title',
    width: 250,
  },
  {
    title: 'SUBJECT',
    dataIndex: 'subject',
    key: 'subject',
    width: 250,
  },
  {
    title: 'ACTIONS',
    width: 120,
    render: (text, record) => <ActionMenu record={record} />,
  },
];

class EmailTemplatesTable extends React.PureComponent {
  render() {
    const { loading, emailTemplates } = this.props.emailTemplatesQuery;

    return (
      <div style={{ marginTop: 50 }}>
        <Table
          rowKey={record => record._id}
          columns={columns}
          loading={loading}
          pagination={{
            defaultPageSize: 5,
          }}
          dataSource={emailTemplates}
        />
      </div>
    );
  }
}

export default graphql(emailTemplatesQuery, { name: 'emailTemplatesQuery' })(EmailTemplatesTable);



// WEBPACK FOOTER //
// ./src/routes/app-studio/EmailTemplatesArea/EmailTemplatesTable/index.js